import { Routes } from '@angular/router';

export type LegacyRouteRedirect = {
    from: string;
    to: string;
};

/**
 * Maps legacy browser URLs to canonical AppRoutes paths.
 * Registered as Angular redirect routes during the URL migration.
 */
export const LEGACY_ROUTE_REDIRECTS: LegacyRouteRedirect[] = [
    // --- /app/main/* → canonical ---
    { from: 'app/main/dashboard', to: '/dashboard' },
    { from: 'app/main/reports', to: '/reports' },
    { from: 'app/main/masters', to: '/masters' },
    { from: 'app/main/quick-start', to: '/quick-start' },
    { from: 'app/main/quick-start-invite-user', to: '/quick-start-invite-user' },
    { from: 'app/main/new-inviteuser', to: '/invite-user' },
    { from: 'app/main/demo', to: '/demo' },
    { from: 'app/main/CommonUiElements', to: '/help-section' },
    { from: 'app/main/CommonUiElements/help_section', to: '/help-section' },
    { from: 'app/main/CommonUiElements/help_section_content', to: '/help-section/content' },

    // appCategory → app-category
    { from: 'app/main/appCategory', to: '/app-category' },

    // Leaves → leaves
    { from: 'app/main/Leaves', to: '/leaves' },
    { from: 'app/main/Leaves/overview', to: '/leaves' },

    // activities
    { from: 'app/main/activities', to: '/activities/time-and-attendance' },
    { from: 'app/main/activities/real-time-tracking', to: '/activities/real-time-tracking' },
    { from: 'app/main/activities/time-and-attendance', to: '/activities/time-and-attendance' },
    { from: 'app/main/activities/apps-and-websites', to: '/activities/apps-and-websites' },
    { from: 'app/main/activities/screenshots', to: '/activities/screenshots' },
    { from: 'app/main/activities/live-screenshots', to: '/activities/live-screenshots' },

    // time-tracking
    { from: 'app/main/time-tracking', to: '/time-tracking' },
    { from: 'app/main/time-tracking/time-tracking', to: '/time-tracking' },
    { from: 'app/main/time-tracking/agent-time-tracking', to: '/time-tracking/agent' },

    // timesheet (new + legacy)
    { from: 'app/main/time-sheet-new', to: '/timesheet' },
    { from: 'app/main/time-sheet-new/time-sheet-management-new', to: '/timesheet' },
    { from: 'app/main/time-sheet', to: '/timesheet' },
    { from: 'app/main/time-sheet/time-sheet-management', to: '/timesheet' },

    // projects-new → projects
    { from: 'app/main/projects-new', to: '/projects' },
    { from: 'app/main/projects-new/projects-new-management', to: '/projects' },
    { from: 'app/main/projects-new/add-new-project', to: '/projects/add' },
    { from: 'app/main/projects-new/project-details', to: '/projects/details' },
    { from: 'app/main/projects-new/add-internal-project', to: '/projects/add-internal' },

    // client-new → clients
    { from: 'app/main/client-new', to: '/clients' },
    { from: 'app/main/client-new/client-new-managment', to: '/clients' },
    { from: 'app/main/client-new/create-or-edit-client', to: '/clients/create-or-edit' },
    { from: 'app/main/client-new/clients-details', to: '/clients/details' },
    { from: 'app/main/client-new/dashboard', to: '/clients/dashboard' },
    { from: 'app/main/client-new/view-selected-client-details', to: '/clients/view-selected' },
    { from: 'app/main/client-new/client-login-view-components/team', to: '/clients/portal/team' },
    { from: 'app/main/client-new/client-login-view-components/task', to: '/clients/portal/task' },
    { from: 'app/main/client-new/client-login-view-components/work-schedule', to: '/clients/portal/work-schedule' },
    { from: 'app/main/client-new/client-login-view-components/all-invoices', to: '/clients/portal/invoices' },
    { from: 'app/main/client-new/client-login-view-components/consult-us', to: '/clients/portal/consult-us' },
    { from: 'app/main/client-new/client-login-view-components/timesheet-details', to: '/clients/portal/timesheet-details' },

    // legacy client
    { from: 'app/main/client', to: '/clients' },
    { from: 'app/main/client/client-managment', to: '/clients' },
    { from: 'app/main/client/create-or-edit', to: '/clients/create-or-edit' },
    { from: 'app/main/client-or-edit', to: '/clients/create-or-edit' },

    // products-and-services
    { from: 'app/main/products-and-services-new', to: '/products-and-services' },
    { from: 'app/main/products-and-services-new/create-or-edit', to: '/products-and-services/create-or-edit' },
    { from: 'app/main/products-and-services', to: '/products-and-services' },
    { from: 'app/main/products-and-services/create-or-edit', to: '/products-and-services/create-or-edit' },

    // legacy project
    { from: 'app/main/project', to: '/projects' },
    { from: 'app/main/project/project-management', to: '/projects' },

    // invoice-list → invoices
    { from: 'app/main/invoice-list', to: '/invoices' },
    { from: 'app/main/invoice-list/invoice-managment', to: '/invoices' },
    { from: 'app/main/invoice-list/invoice-client-or-edit', to: '/invoices/create-or-edit' },

    // --- canonical /app/main/* (post-migration paths) ---
    { from: 'app', to: '/quick-start' },
    { from: 'app/main', to: '/dashboard' },
    { from: 'app/main/app-category', to: '/app-category' },
    { from: 'app/main/clients', to: '/clients' },
    { from: 'app/main/clients/create-or-edit', to: '/clients/create-or-edit' },
    { from: 'app/main/clients/details', to: '/clients/details' },
    { from: 'app/main/clients/dashboard', to: '/clients/dashboard' },
    { from: 'app/main/clients/view-selected', to: '/clients/view-selected' },
    { from: 'app/main/projects', to: '/projects' },
    { from: 'app/main/projects/add', to: '/projects/add' },
    { from: 'app/main/projects/details', to: '/projects/details' },
    { from: 'app/main/projects/add-internal', to: '/projects/add-internal' },
    { from: 'app/main/timesheet', to: '/timesheet' },
    { from: 'app/main/invoices', to: '/invoices' },
    { from: 'app/main/invoices/create-or-edit', to: '/invoices/create-or-edit' },
    { from: 'app/main/leaves', to: '/leaves' },
    { from: 'app/main/invite-user', to: '/invite-user' },

    // --- /app shell routes ---
    { from: 'app/notifications', to: '/notifications' },
    { from: 'app/myProfile', to: '/my-profile' },
    { from: 'app/my-profile', to: '/my-profile' },
    { from: 'app/help-section', to: '/help-section' },
    { from: 'app/company-profile', to: '/company-profile' },
    { from: 'app/company-profile/company-profile', to: '/company-profile' },

    // --- /app/admin/* → /admin/* or /tenant-settings ---
    { from: 'app/admin', to: '/admin/host-dashboard' },
    { from: 'app/admin/hostDashboard', to: '/admin/host-dashboard' },
    { from: 'app/admin/tenants', to: '/admin/tenants' },
    { from: 'app/admin/TrialTenant', to: '/admin/trial-tenant' },
    { from: 'app/admin/editions', to: '/admin/editions' },
    { from: 'app/admin/users', to: '/admin/users' },
    { from: 'app/admin/users-Master', to: '/admin/users' },
    { from: 'app/admin/users/invite-user', to: '/admin/invite-user' },
    { from: 'app/admin/roles', to: '/admin/roles' },
    { from: 'app/admin/languages', to: '/admin/languages' },
    { from: 'app/admin/auditLogs', to: '/admin/audit-logs' },
    { from: 'app/admin/maintenance', to: '/admin/maintenance' },
    { from: 'app/admin/hostSettings', to: '/admin/host-settings' },
    { from: 'app/admin/tenantSettings', to: '/admin/tenant-settings' },
    { from: 'app/admin/organization-units', to: '/admin/organization-units' },
    { from: 'app/admin/subscription-management', to: '/admin/subscription-management' },
    { from: 'app/admin/ui-customization', to: '/admin/ui-customization' },
    { from: 'app/admin/webhook-subscriptions', to: '/admin/webhook-subscriptions' },
    { from: 'app/admin/webhook-subscriptions-detail', to: '/admin/webhook-subscriptions-detail' },
    { from: 'app/admin/webhook-event-detail', to: '/admin/webhook-event-detail' },
    { from: 'app/admin/dynamic-property', to: '/admin/dynamic-property' },
    { from: 'app/admin/new-invite-user', to: '/admin/invite-user' },
    { from: 'app/admin/invite-userprofile', to: '/admin/invite-userprofile' },
    { from: 'app/admin/Superadmin', to: '/admin/super-admin' },
    { from: 'app/admin/explore-user', to: '/admin/explore-user' },
    { from: 'app/admin/install', to: '/admin/install' },
    { from: 'app/admin/demo-ui-components', to: '/admin/demo-ui-components' },
];

/**
 * Redirects from commit-2 flattened paths (without /app/main) to canonical paths.
 */
export const FLATTENED_LEGACY_REDIRECTS: LegacyRouteRedirect[] = [
    { from: 'projects-new', to: '/projects' },
    { from: 'projects-new/projects-new-management', to: '/projects' },
    { from: 'projects-new/add-new-project', to: '/projects/add' },
    { from: 'projects-new/project-details', to: '/projects/details' },
    { from: 'projects-new/add-internal-project', to: '/projects/add-internal' },

    { from: 'client-new', to: '/clients' },
    { from: 'client-new/client-new-managment', to: '/clients' },
    { from: 'client-new/create-or-edit-client', to: '/clients/create-or-edit' },
    { from: 'client-new/clients-details', to: '/clients/details' },
    { from: 'client-new/dashboard', to: '/clients/dashboard' },
    { from: 'client-new/view-selected-client-details', to: '/clients/view-selected' },
    { from: 'client-new/client-login-view-components/team', to: '/clients/portal/team' },
    { from: 'client-new/client-login-view-components/task', to: '/clients/portal/task' },
    { from: 'client-new/client-login-view-components/work-schedule', to: '/clients/portal/work-schedule' },
    { from: 'client-new/client-login-view-components/all-invoices', to: '/clients/portal/invoices' },
    { from: 'client-new/client-login-view-components/consult-us', to: '/clients/portal/consult-us' },
    { from: 'client-new/client-login-view-components/timesheet-details', to: '/clients/portal/timesheet-details' },

    { from: 'time-sheet-new', to: '/timesheet' },
    { from: 'time-sheet-new/time-sheet-management-new', to: '/timesheet' },
    { from: 'time-sheet', to: '/timesheet' },
    { from: 'time-sheet/time-sheet-management', to: '/timesheet' },

    { from: 'products-and-services-new', to: '/products-and-services' },
    { from: 'products-and-services-new/create-or-edit', to: '/products-and-services/create-or-edit' },

    { from: 'Leaves', to: '/leaves' },
    { from: 'Leaves/overview', to: '/leaves' },

    { from: 'invoice-list', to: '/invoices' },
    { from: 'invoice-list/invoice-managment', to: '/invoices' },
    { from: 'invoice-list/invoice-client-or-edit', to: '/invoices/create-or-edit' },

    { from: 'appCategory', to: '/app-category' },
    { from: 'new-inviteuser', to: '/invite-user' },
    { from: 'dashboard', to: '/dashboard' },
    { from: 'app-category', to: '/app-category' },
    { from: 'clients', to: '/clients' },
    { from: 'projects', to: '/projects' },
    { from: 'timesheet', to: '/timesheet' },
    { from: 'invoices', to: '/invoices' },
    { from: 'leaves', to: '/leaves' },
    { from: 'activities', to: '/activities/time-and-attendance' },
    { from: 'time-tracking', to: '/time-tracking' },
    { from: 'reports', to: '/reports' },
    { from: 'masters', to: '/masters' },
    { from: 'quick-start', to: '/quick-start' },
    { from: 'quick-start-invite-user', to: '/quick-start-invite-user' },
    { from: 'invite-user', to: '/invite-user' },
    { from: 'products-and-services', to: '/products-and-services' },
    { from: 'CommonUiElements', to: '/help-section' },
    { from: 'CommonUiElements/help_section', to: '/help-section' },
    { from: 'CommonUiElements/help_section_content', to: '/help-section/content' },

    { from: 'time-tracking/time-tracking', to: '/time-tracking' },
    { from: 'time-tracking/agent-time-tracking', to: '/time-tracking/agent' },

    { from: 'admin/hostDashboard', to: '/admin/host-dashboard' },
    { from: 'admin/auditLogs', to: '/admin/audit-logs' },
    { from: 'admin/hostSettings', to: '/admin/host-settings' },
    { from: 'admin/tenantSettings', to: '/admin/tenant-settings' },
    { from: 'admin/users-Master', to: '/admin/users' },
    { from: 'admin/TrialTenant', to: '/admin/trial-tenant' },
    { from: 'admin/Superadmin', to: '/admin/super-admin' },
    { from: 'admin/new-invite-user', to: '/admin/invite-user' },
];

/**
 * Builds Angular redirect route definitions from the legacy redirect map.
 */
export function buildLegacyRedirectRoutes(): Routes {
    return [...LEGACY_ROUTE_REDIRECTS, ...FLATTENED_LEGACY_REDIRECTS].map(({ from, to }) => ({
        path: from,
        redirectTo: to,
        pathMatch: 'full' as const,
    }));
}
